const DOMAINE = 'Portail';
export const ACTION_MASS_UPDATE_NEWSLETTER = 'updateNewsletter';
export default DOMAINE;
